import React from 'react';
import { ReactComponent as ArrowDownIcon } from '../../assets/novosicones/arrow_down.svg';
import { SelectContainer } from './styles';

export default function Select({
  labelName,
  value,
  optionsArray,
  size,
  disabled,
  handleSelectChange,
  placeholder,
  isError,
  onBlur,
  name,
  title,
  tema,
  errorMessage,
  marginTop,
  id,
}) {
  const inputContainerStyle = {
    marginTop,
    width: size ?? '100%',
  };
  console.log('value', value);
  return (
    <SelectContainer
      style={inputContainerStyle}
      isError={isError}
      tema={tema}
      disabled={disabled}
    >
      {labelName && <label htmlFor={name}>{labelName}</label>}
      <select
        id={id}
        data-testid={name}
        name={name}
        onChange={(e) => {
          handleSelectChange(e.target.value);
        }}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onBlur={onBlur}
        className={value && 'hasValue'}
      >
        {title && (
          <option value='' disabled hidden>
            {title}
          </option>
        )}
        {optionsArray?.map((option) => (
          <option key={option?.value} value={option?.value}>
            {option?.label}
          </option>
        ))}
      </select>

      {value && (
        <input type='radio' checked readOnly className='checked-radio' />
      )}
      <div className='arrow-select'>
        <ArrowDownIcon />
      </div>
      <span className='errorMessage'>{isError && errorMessage}</span>
    </SelectContainer>
  );
}
